module.exports = __webpack_public_path__ + "img/Katarina_home_10.3e82e979.jpg";